import { useEffect, useState } from "react";
import {LottieComponentProps, useLottie} from "lottie-react";

const LazyLottie = (props: {
    animationData: any;
    style?: React.CSSProperties;
}) => {
    const options = {
        animationData: props.animationData,
        loop: true,
        autoplay: true,
    };

    const { View } = useLottie(options, props.style);

    return View;
};

export default LazyLottie;